<template>
  <div class="t-context" ref="t_context">
    <div style="height:100%; width: 100%;" @contextmenu.prevent.stop="showMenu($event)">
      <slot></slot>
    </div>
    <div id="t_context_menu_popup" class="t-context-menu" v-show="show_menu" :style="menu_style" v-click-outside="hideMenu">
      <div v-for="(item, index) in menu_items" v-ripple :key="`t-context-menu-${index}`">
        
        <div class="t-context-menu-item" @click="selectMenuItem(item, null)">
          <TIcon :style="!item.icon ? 'opacity: 0;': ''" :name="item.icon" />
          <TText :text="item.text" />
        </div>
        
        <!-- 2nd level start -->
        <div v-if="Array.isArray(item.key) && show_2nd_level === item.text" class="t-context-menu" 
          :style="`left: ${adjust_left || adjust_left_2nd_level ? '-300': '300'}px; top: ${get2ndLevelTop(item.key, index)}px;`"
        >
          <div v-for="(item_2, index_2) in item.key" v-ripple :key="`t-context-menu-${index_2}-2nd-level`">
            <div @click.prevent.stop="selectMenuItem(item, item_2)" class="t-context-menu-item">
              <TIcon :style="!item_2.icon ? 'opacity: 0;': ''" :name="item_2.icon" />
              <TText :text="item_2.text" />
            </div>
          </div>
        </div>
        <!-- 2nd level end -->

        
      </div>
    </div>
  </div>
</template>
<script>
  import TIcon from '@/components/Taktify/TIcon.component.vue';
  export default {
    props: ['menu_items'],
    components: {
      TIcon
    },
    data: () => ({
      show_menu: false,
      show_2nd_level: false,
      adjust_left: false,
      adjust_top: false,
      adjust_left_2nd_level: false,
      adjust_top_2nd_level: false,
      menu_style: {
        top: '0px',
        left: '0px',
      }
    }),
    methods: {
      get2ndLevelTop(items, index_first_layer){
        const required_height = items.length * 24 + 4;
        const parent_top = parseInt(this.menu_style.top.replace('px', ''));
        let top = index_first_layer * 24;
        const distance_to_bottom = window.innerHeight - parent_top;
        if(distance_to_bottom < required_height){
          top = top - required_height + 24;
        }
        return top;
      },
      selectMenuItem(item, item_2){
        if(Array.isArray(item.key) && item_2 === null){
          this.show_2nd_level = item.text;
          return;
        }
        this.$emit('selectMenuItem', {
          item: item,
          item_2: item_2
        });
        this.hideMenu();
      },
      showMenu(event){
        const parent = event.target;
        const parent_rect = parent.getBoundingClientRect();
        const menu_left = event.clientX - parent_rect.left;
        const menu_top = event.clientY - parent_rect.top;
        const distance_to_right = window.innerWidth - (parent_rect.left + menu_left);
        const distance_to_bottom = window.innerHeight - (parent_rect.top + menu_top);

        const required_width = 300;
        const required_height = this.menu_items.length * 24 + 4;

        // if there is not enough space on the right: move the menu left
        let left = event.clientX;
        if(distance_to_right < required_width){
          left = event.clientX - required_width;
          this.adjust_left = true;
        }

        // check for 2nd layer left / right space
        if (distance_to_right < required_width * 2) {
          this.adjust_left_2nd_level = true;
        }

        // if there is not enough space on the bottom: move the menu up
        let top = event.clientY;
        if(distance_to_bottom < required_height){
          top = event.clientY - required_height;
          this.adjust_top = true;
        }

        this.show_menu = true;

        this.menu_style.top = `${top}px`;
        this.menu_style.left = `${left}px`;
        let app = document.getElementById('app');
        let test = document.getElementById('t_context_menu_popup');
        app.appendChild(test);
      },
      hideMenu(){
        this.show_menu = false;
        this.show_2nd_level = false;
        this.adjust_left = false;
        this.adjust_left_2nd_level = false;
        this.adjust_top = false;
        this.adjust_top_2nd_level = false;
      }
    }
  }
</script>
<style>

  .t-context {
    position: relative;
  }

  .t-context-menu {
    position: fixed;
    display: flex;
    flex-direction: column;
    width: 300px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    z-index: 1000;
    padding: 4px 0px;
  }

  .t-context-menu-item {
    width: 100%;
    height: 24px;
    cursor: pointer;
    padding: 8px 0px;
    padding-left: 8px;
    display: flex;
    align-items: center;
    grid-gap: 8px;
  }

  .t-context-menu-item:hover {
    background-color: #888;
  }
 
</style>
